module.exports = __webpack_public_path__ + "img/sent-icon.5966b55f.svg";